module.exports = __webpack_public_path__ + "static/media/academy_icon_black.a4f6e4f6.svg";